import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember, RelatedOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0651. 発注案件関連受注案件編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/related_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  allocation_ratio: number;
};
const updateRelatedOrder = (props: Props): Promise<RelatedOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/related_orders/${props.id}`,
    props
  );
};

export const useUpdateRelatedOrder = () => {
  return useMutation({
    mutationFn: updateRelatedOrder,
  });
};
